// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table2_container__YWBVJ {
  overflow-x: scroll;
  overflow-y: scroll;
  position: relative;
}

.table2_containerLoader__gYhl5 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.table2_container__YWBVJ table {
  font-family: "Inter";
  max-width: auto;
  max-height: 100%;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  text-align: left;
}

.table2_body__UZKM\\+ {
  overflow: auto;
  font-size: 14px;
}

.table2_header__FPTeJ {
  text-align: center;
  font-size: 1.15em;
  display: table-header-group;
  background-color: transparent;
}

.table2_header__FPTeJ tr th {
  padding: 0.5em 1em;
  /* min-width: 240px; */
  color: var(--neutral-400, #7d7d7d);
  font-size: 14px;
  font-weight: 500;
  border-top: 1px var(--neutral-100, #eeeff2) solid;
  border-bottom: 1px var(--neutral-100, #eeeff2) solid;
}

.table2_head__CITwf {
  padding: 0.4em 0;
  justify-content: space-between;
}

.table2_data__el27n {
  padding: 0.2em 1em;
  /* width: 100vw; */
  font-weight: 500;
}

.table2_data__el27n * {
  margin: 0;
}

.table2_actionButton__GTGW7 {
  background: none;
  border: none;
}

.table2_rowHeader__riZji td {
  font-weight: 600;
}

.table2_rowHeader__riZji td * {
  margin: 0;
}

.table2_reportContainer__\\+YTCG {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  /* border:1px solid #00b894; */
}

.table2_reportHeader__gcyrE {
  width: 100%;
  color: white;
  font-weight: 600;
  font-size: 1em;
  display: table-header-group;
  background-color: #055437;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/table2.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,8BAAA;AAAF;;AAGA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;AAAF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;EACA,oDAAA;AACF;;AAEA;EACE,gBAAA;EACA,8BAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,8BAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;EACA,yBAAA;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap');\n\n.container {\n  overflow-x: scroll;\n  overflow-y: scroll;\n  position: relative;\n}\n\n.containerLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.container table {\n  font-family: 'Inter';\n  max-width: auto;\n  max-height: 100%;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  text-align: left;\n}\n\n.body {\n  overflow: auto;\n  font-size: 14px;\n}\n.header {\n  text-align: center;\n  font-size: 1.15em;\n  display: table-header-group;\n  background-color: transparent;\n}\n\n.header tr th {\n  padding: 0.5em 1em;\n  /* min-width: 240px; */\n  color: var(--neutral-400, #7d7d7d);\n  font-size: 14px;\n  font-weight: 500;\n  border-top: 1px var(--neutral-100, #eeeff2) solid;\n  border-bottom: 1px var(--neutral-100, #eeeff2) solid;\n}\n\n.head {\n  padding: 0.4em 0;\n  justify-content: space-between;\n}\n\n.data {\n  padding: 0.2em 1em;\n  /* width: 100vw; */\n  font-weight: 500;\n}\n\n.data * {\n  margin: 0;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n}\n\n.rowHeader td {\n  font-weight: 600;\n}\n.rowHeader td * {\n  margin: 0;\n}\n\n.reportContainer {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  /* border:1px solid #00b894; */\n}\n\n.reportHeader {\n  width: 100%;\n  color: white;\n  font-weight: 600;\n  font-size: 1em;\n  display: table-header-group;\n  background-color: #055437;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table2_container__YWBVJ`,
	"containerLoader": `table2_containerLoader__gYhl5`,
	"body": `table2_body__UZKM+`,
	"header": `table2_header__FPTeJ`,
	"head": `table2_head__CITwf`,
	"data": `table2_data__el27n`,
	"actionButton": `table2_actionButton__GTGW7`,
	"rowHeader": `table2_rowHeader__riZji`,
	"reportContainer": `table2_reportContainer__+YTCG`,
	"reportHeader": `table2_reportHeader__gcyrE`
};
export default ___CSS_LOADER_EXPORT___;
